import truncate from 'lodash/truncate';

export default {
  data() {
    return {
      optionsPointSummaryBar: {
        maintainAspectRatio: false,
        segmentShowStroke: false,
        legend: {
          display: true,
        },
        scales: {
          yAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
                min: 0,
                maxTicksLimit: 1,
                stepSize: 10,
              },
            },
          ],
          xAxes: [
            {
              stacked: true,
              ticks: {
                autoSkip: false,
                minRotation: 45,
                callback: (value) => {
                  const options = {
                    length: 15,
                    separator: '',
                  };
                  return truncate(value, options);
                },
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            title: (tooltipItems, data) => {
              const pointType = data.labels[tooltipItems[0].index];
              return pointType;
            },
          },
        },
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/pointSummaryBarChartOptions.js